import React from 'react';
import { Button } from '@material-ui/core';

import { appStyles } from '../_styles';

/**
 * ACTMT form button.
 * TODO: Test
 * @param {object} prop React property object.
 * React Component (https://reactjs.org/docs/react-component.html)
 */
const AmFormButton = (prop: any) => {
  // Hook to create classes used to style the button.
  const classes = appStyles();
  return (
    <Button
      type="submit"
      fullWidth
      disabled={prop.disabled}
      variant="contained"
      color="primary"
      className={classes.submit}
    >
      {prop.children}
    </Button>
  );
};

export { AmFormButton };
